import { render, staticRenderFns } from "./IconLogo.vue?vue&type=template&id=4dabe1e0&"
import script from "./IconLogo.vue?vue&type=script&lang=ts&"
export * from "./IconLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports